export default "__VITE_ASSET__dc743116__"